__turbopack_context__.v({
  "appAlert": "lc8c6q_appAlert",
  "appAlertBody": "lc8c6q_appAlertBody",
});
